import React, {Suspense, useState} from 'react';
import useIntersectionObserver from '@stencil/use-intersection-observer';
import {detailsNavigationIds} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';
import RoomFlavorLoader from '../../../../../stories/components/hotels/Loadingpage/RoomTypeLoader/RoomTypeLoader';
const RoomSelectionComponent = React.lazy(() => import('./RoomSelection'));

const RoomSelectionChunk = () => {
  return (
    <Suspense fallback={<RoomFlavorLoader />}>
      <RoomSelectionComponent />
    </Suspense>
  );
};

const intersectionObserverOptions = {
  root: null,
  threshHold: 0.01,
};

const RoomSelection = () => {
  const [visible, setVisible] = useState(false);

  const [watcherRef] = useIntersectionObserver(intersectionObserverOptions, () => {
    setVisible(true);
  });

  return (
    <div ref={watcherRef} id={detailsNavigationIds.rooms}>
      {(visible && <RoomSelectionChunk />) || null}
    </div>
  );
};

export default RoomSelection;
